import React, { useEffect } from "react";
import { Container, Row, Col } from "react-grid-system";
import { Field, useFormState } from "react-final-form";
import ReactGA from "react-ga";

import {
  Error,
  required,
  isEmail,
  composeValidators,
  requiredIf,
  requiredIfNot,
} from "../components/Validation";
import Fade from "../animate/Fade";
import PhoneNumberField from "../components/PhoneNumberField";

const YourDetails = () => {
  const { values } = useFormState();
  useEffect(() => {
    ReactGA.event({
      category: "Move Calculator",
      action: "Step",
      label: "Your Details",
    });
  }, []);
  return (
    <Fade show>
      <Container className="form-fields row">
        <Row>
          <div className="page-title">
            {(values && values.international) || values.live_in === "other" ? (
              <>
                <h3>
                  {values.live_in === "other"
                    ? "Looks like we'll need a bit more information about your move."
                    : "It sounds like you are planning an international move."}
                  <br />
                  <strong>We can definitely help!</strong>
                </h3>
                <p>
                  Please provide a little more information and a relocation
                  specialist will be in touch. If you need help immediately call
                  855-336-1151
                </p>
              </>
            ) : (
              <h3>You will get your quote in the next step!</h3>
            )}
          </div>

          <Col sm={12} md={6} className="form-fields__block">
            <label htmlFor="firstname">
              First Name
              <Field
                name="firstname"
                component="input"
                type="text"
                className="input"
                validate={required()}
              />
            </label>
            <Error name="firstname" />
          </Col>
          <Col sm={12} md={6} className="form-fields__block">
            <label htmlFor="lastname">
              Last Name
              <Field
                name="lastname"
                component="input"
                type="text"
                className="input"
                validate={required()}
              />
            </label>
            <Error name="lastname" />
          </Col>
          <Col sm={12} md={6} className="form-fields__block">
            <label htmlFor="email">
              Email Address
              <Field
                name="email"
                parse={(v) => v.trim()}
                validate={composeValidators(
                  required("Please provide an email address"),
                  isEmail
                )}
                component="input"
                type="text"
                className="input"
              />
            </label>
            <Error name="email" />
          </Col>
          <Col sm={12} md={6} className="form-fields__block">
            <label htmlFor="phone">
              Phone Number
              <PhoneNumberField
                name="phone"
                validate={required()}
                component="input"
                type="text"
                className="input"
              />
            </label>
            <Error name="phone" />
          </Col>
          <Col sm={12} md={6} className="form-fields__block">
            <label htmlFor="coupon">
              Referral / Coupon Code
              <Field
                name="coupon"
                component="input"
                type="text"
                className="input"
              />
            </label>
          </Col>
          {values && values.international && (
            <Col sm={12} className="form-fields__block">
              <label htmlFor="move_info">
                Tell us about your move:
                <Field
                  name="move_info"
                  component="textarea"
                  type="text"
                  className="input"
                  validate={requiredIf("international")}
                />
              </label>
              <Error name="move_info" />
            </Col>
          )}
          {values && values.live_in === "other" && (
            <Col sm={12} className="form-fields__block">
              <label htmlFor="move_info">
                Tell us about your move:
                <Field
                  name="move_info"
                  component="textarea"
                  type="text"
                  className="input"
                  validate={requiredIfNot("international")}
                />
              </label>
              <Error name="move_info" />
            </Col>
          )}
          <Col sm={12} className="form-fields__block">
            <label className="checkbox-wrap" htmlFor="repeat_client">
              <Field
                id="repeat_client"
                name="repeat_client"
                component="input"
                type="checkbox"
                value="true"
                className="checkbox"
                parse={(v) => !!v[0]}
                format={(v) => [v ? "true" : "false"]}
              />{" "}
              I have moved with you in the past
            </label>
          </Col>
        </Row>
      </Container>
    </Fade>
  );
};

export default YourDetails;
